import React from "react";
import { Alert } from "@arcteryx/components-alerts-overlays";
import styled from "styled-components";

const StyledAdvisoryMsg = styled(Alert)`
  font-family: var(--font-urw);
  margin: 2rem 0;
  border-width: 0;
  p {
    span,
    span a {
      color: var(--warning-red) !important;
    }
  }
`;

const FsAdvisoryMsg = ({ text, hideFormBanner }) => {
  return (
    hideFormBanner ? null :
    <StyledAdvisoryMsg type="advisory">
      <div dangerouslySetInnerHTML={{ __html: text }} />
    </StyledAdvisoryMsg>
  );
};

export default FsAdvisoryMsg;
